import React from 'react';
import {ScrollView, StyleSheet, TextInput, TouchableOpacity, View} from 'react-native';
import Header from '../components/ClientHeader';
import {Text, withTheme} from "react-native-paper";
import {useMst} from "../models/RootModel";
import {observer} from "mobx-react-lite";
import {useMediaQuery} from "react-responsive";
import Footer from "../components/Footer";
import Copyright from "../components/Copyright";
import Login from "../components/Login";
import i18n from "../translations/Translations";
import {NetworkService} from "../services/NetworkService";
import {useNavigation} from "@react-navigation/native";
const CryptoJS = require("crypto-js");

export interface CreateAccountPageRestaurantProps {
    theme: ReactNativePaper.Theme,
    backTo?: string
}

const CreateAccountPageRestaurant = observer((props: CreateAccountPageRestaurantProps) => {
    const state = useMst();
    const navigation = useNavigation();


    const [email, setEmail] = React.useState("");
    const [name, setName] = React.useState("");
    const [surname, setSurname] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [rePassword, setRePassword] = React.useState("");
    const [message, setMessage] = React.useState("");

    const styles = StyleSheet.create({
        container: {
            backgroundColor: "white"
        },
        input_label: {
            fontFamily: props.theme.fontList.primaryFontDefault,
            fontSize: 15,
            color: "#aaaaaa",
            letterSpacing: 2,
            marginBottom: 10,
            marginTop: 20
        },
        input: {
            alignSelf: "center",
            height: 36,
            width: "100%",
            outlineColor: "#00000000",
            backgroundColor: "#eeeeee",
            paddingLeft: 16,
            paddingRight: 16,
            fontFamily: props.theme.fontList.primaryFontDefault,
            letterSpacing: 2
        },
        logo: {
            width: 450,
            height: 200,
            marginBottom: 40,
            resizeMode: "contain",
            alignSelf: "center"
        },
        button: {
            marginHorizontal: 10,
            backgroundColor: props.theme.colors.button_color,
            width: "100%",
            height: 36
        },
        button_text: {
            color: "white",
            alignSelf: "center",
            marginVertical: "auto",
            fontFamily: props.theme.fontList.primaryFontBold,
            letterSpacing: 3
        },
        bottom_text_wrapper: {
            flexDirection: "row",
            marginTop: 30,
            width: "100%",
            justifyContent: "space-between"
        },
        login_error: {
            marginTop: 28,
            marginBottom: 10,
            fontSize: 14,
            alignSelf: "center",
            flexWrap: "wrap",
            color: props.theme.colors.button_color
        },
        description: {
            fontFamily: props.theme.fontList.primaryFontDefault,
            fontSize: 14,
            marginTop: 18,
            marginBottom: 4
        },
        content: {
            width: 500,
            elevation: 4,
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: "center",
            zIndex: -1,
            borderStyle: "solid",
            borderWidth: 1,
            marginTop: 40,
            padding: 30,
            paddingHorizontal: 50
        },
        title: {
            color: props.theme.colors.primary,
            backgroundColor: "white",
            textTransform: "uppercase",
            fontFamily: props.theme.fontList.primaryFontBlack,
            fontSize: 20,
            position: "absolute",
            top: -15,
            left: 15,
            paddingLeft: 8,
            paddingRight: 8
        },
        buttons: {
            paddingTop: 6,
            paddingHorizontal: 24,
            paddingBottom: 6,
        },
        buttons_text:{
            textTransform: "uppercase",
            fontFamily: props.theme.fontList.primaryFontExtraBold,
            fontSize: 16
        },
        cancel_button: {
            backgroundColor: "#6c6c6c",
        },
        cancel_button_text: {
            color: "#959595"
        }
    });


    function createAccount() {
        if (!email.length || !name.length || !surname.length || !password.length || !rePassword.length) {
            setMessage(i18n.t("account.create_account.error.empty"));
            return;
        }

        // Validate email
        let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (!reg.test(email)){
            setMessage(i18n.t("account.create_account.error.email"));
            return;
        }

        // Validate passwords
        if (password != rePassword){
            setMessage(i18n.t("account.create_account.error.password_match"));
            return;
        }

        NetworkService.postRequest("api/create_account", {
            email: email,
            name: name,
            surname: surname,
            password: CryptoJS.SHA1(password).toString()
        }).then(response => {
            if (response.status){
                switch (response.status){
                    case 406:
                        setMessage(i18n.t("account.create_account.error.params"));
                        break;
                    case 409:
                        setMessage(i18n.t("account.create_account.error.already_used"));
                        break;
                }
                return;
            }
            setEmail("");
            setName("");
            setSurname("");
            setPassword("");
            setRePassword("");
            // navigation.navigate("login");
            setMessage(i18n.t("account.create_account.activation_info"));
        })
    }

    return (
        <View style={styles.container}>
            <ScrollView style={{height: "100vh", paddingBottom: 32}}>
                <Header/>
                <View style={styles.content}>
                    <Text style={styles.title}>{i18n.t("account.create_account.title")}</Text>
                    <Text style={styles.description}>{i18n.t("account.create_account.description")}</Text>
                    <Text style={styles.input_label}>{i18n.t("account.create_account.email")}</Text>
                    <TextInput style={styles.input}
                               value={email}
                               textContentType={"emailAddress"}
                               onChangeText={text => {
                                   setMessage("");
                                   setEmail(text);
                               }}
                    />
                    <Text style={styles.input_label}>{i18n.t("account.create_account.name")}</Text>
                    <TextInput style={styles.input}
                               value={name}
                               textContentType={"name"}
                               onChangeText={text => {
                                   setMessage("");
                                   setName(text);
                               }}
                    />
                    <Text style={styles.input_label}>{i18n.t("account.create_account.surname")}</Text>
                    <TextInput style={styles.input}
                               value={surname}
                               textContentType={"familyName"}
                               onChangeText={text => {
                                   setMessage("");
                                   setSurname(text);
                               }}
                    />
                    <Text style={styles.input_label}>{i18n.t("account.create_account.password")}</Text>
                    <TextInput style={styles.input}
                               value={password}
                               secureTextEntry={true}
                               textContentType={"password"}
                               onChangeText={text => {
                                   setMessage("");
                                   setPassword(text);
                               }}
                    />
                    <Text style={styles.input_label}>{i18n.t("account.create_account.rePassword")}</Text>

                    <TextInput style={styles.input}
                               value={rePassword}
                               secureTextEntry={true}
                               textContentType={"password"}
                               onChangeText={text => {
                                   setMessage("");
                                   setRePassword(text);
                               }}
                    />
                    <Text style={styles.login_error}>{message}</Text>
                    <TouchableOpacity activeOpacity={props.theme.defaultTouchableOpacity} style={styles.button}
                                      onPress={createAccount}>
                        <Text style={styles.button_text}>{i18n.t("account.create_account.btn")}</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[styles.buttons, styles.cancel_button, {marginTop: 20}]} onPress={() => {
                        history.back();
                    }} activeOpacity={props.theme.defaultTouchableOpacity}>
                        <Text style={[styles.buttons_text, styles.cancel_button_text]}>{i18n.t("common.back")}</Text>
                    </TouchableOpacity>
                </View>
            </ScrollView>
        </View>
    );
})

export default withTheme(CreateAccountPageRestaurant);